<app-cargando *ngIf="cargando"></app-cargando>

<div class="modal-content dark-mode">

  <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Crear Oportunidad</h4>
  </div>

  <div class="modal-body">

    <button type="button" class="btn boton-crear" (click)="crearOportunidadTabla()">
      Crear Oportunidad
    </button>

    <div style="text-align: center;" *ngIf="oportunidadSeleccionada">
      <h4>
        {{oportunidadSeleccionada.Name}}
      </h4>

      <br>

      <div class="row">

        <div class="form-group col-sm-6">
          <label class="control-label" for="Etapa">Etapa</label>
          <select class="Contactos form-control select2-hidden-accessible" style="width: 100%" [(ngModel)]="oportunidadOPR1.Step_Id">
            <option *ngFor="let item of Etapas" value="{{item.StepId}}">
              {{item.Descript}}
            </option>
          </select>
        </div>

        <div class="form-group col-sm-6">
          <label class="control-label" for="Fecharequeridacliente">
            Comentario
          </label>

          <input [(ngModel)]="oportunidadOPR1.Memo" class="form-control text-box single-line" type="text"/>
          <span class="field-validation-valid text-danger"></span>
        </div>

      </div>

    </div>

  <ngx-table class="ngx-seguimiento-oportunidad" *ngIf="!oportunidadSeleccionada" #table [configuration]="configuration" [data]="data" [columns]="columns"></ngx-table>

  <ng-template #frmAccion let-row let-rowIndex="rowIndex">
    <button type="button" class="btn boton-crear" style="font-size: 16px;" (click)="seleccionarOportunidad(row)">
      <button mat-raised-button style="background: #91CA41;color: #454D55;">Seleccionar</button>
    </button>
  </ng-template>

  <ng-template #frmCreateDate let-row let-rowIndex="rowIndex">
    {{row.CreateDate | date:'dd/MM/yyyy'}}
  </ng-template>

  <ng-template #frmPredDate let-row let-rowIndex="rowIndex">
    {{row.PredDate | date:'dd/MM/yyyy'}}
  </ng-template>

  <ng-template #frmCloPrcnt let-row let-rowIndex="rowIndex">
    <div class="progress" *ngIf="row.CloPrcnt <= 25">
      <div class="progress-bar" style="width: 100%;background-color: rgb(221, 65, 65);" [style]="'width: '+row.CloPrcnt+'%'">
        {{row.CloPrcnt}} %
      </div>
    </div>
    <div class="progress" *ngIf="row.CloPrcnt <= 50 && row.CloPrcnt > 25">
      <div class="progress-bar" style="width: 100%;background-color: rgb(244, 215, 50);color: #454D55;" [style]="'width: '+row.CloPrcnt+'%'">
        {{row.CloPrcnt}} %
      </div>
    </div>
    <div class="progress" *ngIf="row.CloPrcnt <= 75 && row.CloPrcnt > 50">
      <div class="progress-bar" style="width: 100%;background-color: rgb(65, 166, 221);" [style]="'width: '+row.CloPrcnt+'%'">
        {{row.CloPrcnt}} %
      </div>
    </div>
    <div class="progress" *ngIf="row.CloPrcnt <= 100 && row.CloPrcnt > 75">
      <div class="progress-bar" style="width: 100%;background-color: rgb(92, 190, 87);" [style]="'width: '+row.CloPrcnt+'%'">
        {{row.CloPrcnt}} %
      </div>
    </div>
  </ng-template>

  <ng-template #frmSlpCode let-row let-rowIndex="rowIndex">

    <div *ngFor="let item of listaVendedor">
      <div *ngIf="item.SlpCode == row.SlpCode">
        {{item.SlpName}}
      </div>
    </div>

  </ng-template>

  <ng-template #frmStepLast let-row let-rowIndex="rowIndex">
    <div *ngFor="let item of Etapas">
      <div *ngIf="row.StepLast == item.StepId">
        {{item.Descript}}
      </div>
    </div>
  </ng-template>


  </div>

  <div class="modal-footer">
      <button type="button" class="btn btn-default" (click)="cerrar()" style="background: #fa5353;color: white;">Cerrar</button>
      <button type="button" class="btn btn-default" *ngIf="oportunidadSeleccionada" style="background: #3fbeff;color: white;" (click)="limpiarOportunidad()">Volver</button>
      <button type="button" class="btn btn-success" *ngIf="oportunidadSeleccionada && !desdeVenta" (click)="crearOportunidad()">Crear Oportunidad</button>
      <button type="button" class="btn btn-success" *ngIf="oportunidadSeleccionada && desdeVenta" (click)="crearOportunidad()" >Generar Documento</button>
  </div>

</div>
